(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GPTTokenizer_r50k_base", [], factory);
	else if(typeof exports === 'object')
		exports["GPTTokenizer_r50k_base"] = factory();
	else
		root["GPTTokenizer_r50k_base"] = factory();
})(globalThis, () => {
return 